var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManufacturer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 1700",
    width: 1280,
    height: 1280,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(105,403)",
    d: "m0 0h281l11 1 6 3 5 6 2 9v347l-1 2 17-8 15-7 59-26 30-13 29-13 25-11 39-17 29-13 37-16 29-13 30-13 43-19 64-28 35-15 16-7 7-2h9l8 3 9 6 6 9 1 3v186l15-6 24-11 20-9 43-19 35-15 29-13 61-27 39-17 27-12 46-20 34-15 46-20 27-12 21-9 8-2h7l11 3 8 6 5 8 1 2 1 10v173l-1 5 53-23 29-13 18-8 98-43 141-62 42-18 38-17 35-15 16-7 5-1h8l9 3 9 6 4 5 2 4 1 16v932l-1 64-6 7-8 6-3 1-11 1h-1812l-12-3-10-6-12-12-9-14-3-17-1-26v-1091l3-12 6-7 9-3zm522 610-33 1-8 2-7 6-3 7-1 5-1 53v140l1 29 3 10 5 6 7 3 15 2h123l9-2 8-5 6-10 2-12v-102l-1-111-3-9-6-8-4-3-6-1-40-1zm1009 0-29 1-7 2-6 7-4 10-1 5v217l3 9 5 6 10 5 13 2h123l9-2 9-6 5-8 1-5v-198l-1-25-4-11-7-7-8-1-38-1zm-483 0-48 1-11 2-6 5-4 7-1 4-1 13-1 140v34l1 35 3 10 5 7 9 4 12 2h127l10-3 7-6 3-7 1-5 1-15v-203l-2-9-5-8-6-6-6-1-41-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(164,190)",
    d: "m0 0h183l42 1 13 2 4 4 3 9 1 10v91l-5 10-6 5-10 3-215 1h-62l-22-1-7-4-6-7-3-7-1-16 1-79 3-12 3-5 6-3 10-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1960,702)",
    d: "m0 0h1v814l-1 46-3-3-1-3v-43l1-69 1-35v-148l-2-108v-54l1-84 1-21 1-51-1-58-1-31v-17l1-25 1-85z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1166 1e3)",
    d: "m0 0h18l17 1 12 2 5 4-2 1-63 1h-46v-1l14-2 1-3 3-1 16-1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(752,1037)",
    d: "m0 0 2 2 2 96v109l-2 8h-2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1766,1036)",
    d: "m0 0 2 1 1 13 1 61v132l-1 8-2 1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(652,1006)",
    d: "m0 0h38l19 4v1l20 1 2 2h-38l-65-1-3-1v-2h-3v-2l4-1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1960,702)",
    d: "m0 0h1v242l-2-1-1-58-1-31v-17l1-25 1-85z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1082,1035)",
    d: "m0 0h1l-1 150v64l-2-2-1-7v-118l1-45v-29l1-12z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1648,1007)",
    d: "m0 0h52l12 2 3 1v2h26l5 1v1h-37l-66-1-1-4z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(944,572)",
    d: "m0 0 2 1v181h-2l-1-8v-119z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1080,1207)",
    d: "m0 0h1l1 12v30l-2-2-1-7v-32z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1421,550)",
    d: "m0 0h7l8 2v1h-15l-3-2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(913,550)",
    d: "m0 0h9l4 2-17 1v-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturer);
export default __webpack_public_path__ + "static/media/manufacturer.8696b03e66c9a5f72146d02292848822.svg";
export { ForwardRef as ReactComponent };